const sidebar: Record<string, string> = {
    scrollToError: 'Scroll to error{count, plural, one {} other {s}}',
};

export default sidebar;
